module.exports = __webpack_public_path__ + "img/headshot6.8afb03da.jpg";